export default "__VITE_ASSET__DBZAcZig__"